import { render, staticRenderFns } from "./NavBread.vue?vue&type=template&id=062605ce&scoped=true"
import script from "./NavBread.vue?vue&type=script&lang=js"
export * from "./NavBread.vue?vue&type=script&lang=js"
import style0 from "./NavBread.vue?vue&type=style&index=0&id=062605ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062605ce",
  null
  
)

export default component.exports